import { render, staticRenderFns } from "./modal-acto-violencia.vue?vue&type=template&id=19a1e66d"
import script from "./modal-acto-violencia.vue?vue&type=script&lang=js"
export * from "./modal-acto-violencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports